import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

export const saveFCMToken = (obj: any): any => {
  return axios.post(`/fcm/business/user/token/update`, obj);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof saveFCMToken>;
};

export const useSaveFCMToken = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: saveFCMToken,
  });
};
